export class Global {
  static AppVersion = "1.0.2"
}